import React from 'react';
import { Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import { useRoles } from 'src/provider/UserRoleProvider';
import { ErrorPage } from '@im/ui-lib/ErrorPage';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import { useTranslate } from '@im/react-localization';
import AcopMaintenance from './AcopMaintenance/AcopMaintenance';

export function AcopMaintenanceRoute() {
  const { updatePageTitle } = usePageTitle();
  const translate = useTranslate();
  updatePageTitle(translate('AcopMaintenance.PageTitle'));
  const { isCOGUser } = useRoles();

  return (
    <NestedApiLocalizationProvider
      preloadResources={['AcopMaintenance', 'Common']}
    >
      {isCOGUser ? (
        <Routes>
          <Route element={<AcopMaintenance />} path="" />
        </Routes>
      ) : (
        <Routes>
          <Route
            element={
              <ErrorPage
                data-testid="gds-vp-access-denied-page"
                errorCode="403"
                errorText={translate('Common.AccessDeniedDescription')}
                message={translate('Common.AccessDenied')}
                showHomeButton
              />
            }
            path="*"
          />
        </Routes>
      )}
    </NestedApiLocalizationProvider>
  );
}
